// Module
var code = "<md-content class=\"sb-background-info\"> <div class=\"sb-trascluded-content\" ng-class=\"type=='loader'? 'loading':''\" ng-transclude></div> <sb-loading ng-if=\"type=='loader'\"></sb-loading> </md-content> ";
// Exports
var _module_exports =code;;
var path = '/var/lib/jenkins/workspace/Sablono_sb-bimtime_master/app/scripts/common/ui-elements/directives/sbBackgroundInfo/sbBackgroundInfo.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;